import * as React from "react";
import { DynamicModuleLoader } from "redux-dynamic-modules";
import { profileModule } from "../../../modules/manage-profile/redux/profile";
import { OnBoardingInvestor as ConnectedOnBoardingInvestor } from "../../../modules/manage-profile/onboarding-investor";

export const OnBoardingInvestor = () => (
  <DynamicModuleLoader modules={[profileModule]}>
    <ConnectedOnBoardingInvestor />
  </DynamicModuleLoader>
);
